<template>
  <div id="app" ref="app">
    <navbar v-if="!showMobile" id="navbar" ref="navbar" />
    <navbar-mobile v-else id="navbar-mobile"></navbar-mobile>
    <router-view id="app-main" />
    <footer-bar v-if="!showMobile" id="footer" />
    <footer-mobile v-else id="footer-mobile" />
  </div>
</template>

<script>
import navbar from '@/pc/components/navbar.vue';

import footerBar from '@/pc/components/footer.vue';

import fixedBar from '@/pc/components/fixedbar.vue';
import navbarMobile from '@/mobile/components/navbar.vue';
import footerMobile from '@/mobile/footer/footer.vue';
// import navbarMobile from '@/mobile/components/navbar-menu.vue';
const { body } = document;
export default {
  components: {
    navbar,
    footerBar,
    fixedBar,
    navbarMobile,
    footerMobile
  },
  data() {
    return {
      showMobile: false
    };
  },

  created() {
    this.isMobile = sessionStorage.getItem('isMobile') == 'isMobile';
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted() {
    this._isMobile();
    if (document.querySelector('#app')) {
      document.querySelector('#app').addEventListener('mouseenter', () => {
        this.$refs.navbar.close();
      });
    }
  },
  methods: {
    $_isMobile() {
      // 视口定位
      const rect = body.getBoundingClientRect();
      console.log(rect);
      return rect.width - 1 < 1065;
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile();
        this.showMobile = false;
        if (isMobile) {
          this.showMobile = true;
        }
      }
    },
    _isMobile() {
      const flag = /Android|iPhone|iPad|iPod|BlackBerry|webOS|Windows Phone|SymbianOS|IEMobile|Opera Mini/i.test(navigator.userAgent);
      this.showMobile = flag;
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  position: relative;
  width: 100%;
  #navbar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
  #app-main {
    padding-top: 60px; // 暂时不要将其content样式写死
    background: #eef0f3;
    min-height: 520px;
    height: auto;
  }
  @media screen and (max-width: 1065px) {
    #app-main {
      padding-top: 0px; // 暂时不要将其content样式写死
      background: #eef0f3;
      height: auto;
      top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue